import { OperationService } from "@/services";
import $thousandMask from "@/mixins/thousandMask";
import dayjs from "dayjs";
export default {
  name: "resubmit-sell",
  components: {},
  mixins: [$thousandMask],
  filters: {
    dateTimeFilter(date) {
      return (
        dayjs(date).format("HH:mm") + " - " + dayjs(date).format("YYYY/MM/DD")
      );
    }
  },
  props: [],
  data() {
    return {
      typeOfOrderStatus: "",
      orderData: {},
      loading: false,
      copyFlag: true
    };
  },
  computed: {},
  mounted() {
    this.getOrderData(this.$route.params.id);
  },
  methods: {
    getOrderData(id) {
      this.loading = true;
      OperationService.showOrder(id)
        .then(response => {
          if (response.data.data.status === "EXPIRED") {
            this.typeOfOrderStatus = true;
          } else {
            this.typeOfOrderStatus = false;
          }
          this.orderData = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createOrderTransactionId() {
      if (this.copyFlag) {
        this.copyFlag = false;
        this.$toast.success(this.$t("orderProcessPage.txNumberCopied"));
      } else {
        setTimeout(() => {
          this.copyFlag = true;
        }, 3000);
      }
    }
  }
};
